export class DestinationCountryFilterValueConverter {
    toView(country, searchTerm, filterStartCharCount, filterSearchFunction, resorts, language) {

        if (!searchTerm || searchTerm.length < filterStartCharCount) return true;

        let res;

        switch (filterSearchFunction) {
            case 'startsWith':
                res = resorts.find((item) => {
                    return item.text.toUpperCase().startsWith(searchTerm.toUpperCase());
                });
                if (res === undefined){
                    res = country.text.toUpperCase().startsWith(searchTerm.toUpperCase()) == false ? undefined : 0;
                }
                break;
            case 'includes':
            default:
                res = resorts.find((item) => {
                    return item.text.toUpperCase().includes(searchTerm.toUpperCase());
                });
                if (res === undefined){
                    res = country.text.toUpperCase().includes(searchTerm.toUpperCase()) == false ? undefined : 0;
                }
                break;
        }

        if (res === undefined) {
            return false;
        }

        return true;
    }
}
